export interface IPayload {
    donationYear: string,
    includeDash: boolean,
    includeNkr: boolean,
    minReferrals: string,
    centerType: string, // replaces detail
    organType: number // replaces cookie
    isMicrosite: number
}
